/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LandingPageBlogUpdateRequest = {
    bootCampCategory?: LandingPageBlogUpdateRequest.bootCampCategory;
    sequence?: number;
    title?: string;
    contents?: string;
    forwardLink?: string;
    id?: number;
};

export namespace LandingPageBlogUpdateRequest {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }


}

